import React, { useEffect, useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Standard } from '@getvim/vim-connect';
import useLocalStorage from 'react-localstorage-hook';
import { isEmpty } from 'lodash-es';
import { EncounterStart } from '../../mocks/standard-events';
import { FlexBox } from '../common/FlexBox';
import { MonacoEditor } from '../monaco-editor';

export const EncounterStartTab = () => {
  const [payload, setPayload] = useState<Standard.Events.EncounterStartPayload>();
  const [predefinedPayload, setPredefinedPayload] = useState<string>('');
  const [lastUsedPayload, setLastUsedPayload] = useLocalStorage('lastEncounterStartPayload', '');
  const [, setShouldPublish] = useLocalStorage('shouldPublishEncounterStart', false);

  useEffect(() => {
    handlePredefinedPayloadChange({ target: { value: lastUsedPayload } } as SelectChangeEvent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setShouldPublish(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePublish = () => setShouldPublish(true);

  const handlePredefinedPayloadChange = ({ target: { value } }: SelectChangeEvent) => {
    setPredefinedPayload(value);
    setLastUsedPayload(value);
    setPayload(EncounterStart.predefinedPayloads[value]);
  };

  return (
    <Accordion id="encounterStartTab">
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography>encounterStart</Typography>
        <Select
          displayEmpty
          value={predefinedPayload}
          id="encounter-start-select"
          size="small"
          onChange={handlePredefinedPayloadChange}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <MenuItem value="">Choose</MenuItem>
          {Object.keys(EncounterStart.predefinedPayloads).map((value) => (
            <MenuItem
              value={value}
              key={value}
              id={`encounter-start-${value.replaceAll(' ', '-')}`}
            >
              {value}
            </MenuItem>
          ))}
        </Select>

        <Button
          id="publish-encounter-start"
          disabled={isEmpty(predefinedPayload)}
          fullWidth
          onClick={(e) => {
            e.stopPropagation();
            handlePublish();
          }}
          variant="contained"
        >
          Publish
        </Button>
      </AccordionSummary>
      <AccordionDetails>
        <MonacoEditor onChange={setPayload} height="20rem" value={payload} />

        <FlexBox>
          <TextField
            id="encounterStartPayload"
            variant="outlined"
            size="small"
            value={JSON.stringify(payload)}
            sx={{ display: 'none' }}
          />
        </FlexBox>
      </AccordionDetails>
    </Accordion>
  );
};
